import { Component, input } from '@angular/core';

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.css'],
})
export class AvatarComponent {
    readonly label = input<string>();
    readonly text = input<string>();
}
